var _mask, _path, _path2, _path3, _rect, _rect2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadlockClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_348_3514",
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 6,
    width: 90,
    height: 67,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 36,
    y: 6,
    width: 90,
    height: 67
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124 71V51C124 27.2518 104.748 8 81 8C57.2518 8 38 27.2518 38 51V71H50V51C50 33.8792 63.8792 20 81 20C98.1208 20 112 33.8792 112 51V71H124Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124 71V51C124 27.2518 104.748 8 81 8C57.2518 8 38 27.2518 38 51V71H50V51C50 33.8792 63.8792 20 81 20C98.1208 20 112 33.8792 112 51V71H124Z",
    fill: "#0FE90C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124 71V73H126V71H124ZM38 71H36V73H38V71ZM50 71V73H52V71H50ZM112 71H110V73H112V71ZM122 51V71H126V51H122ZM81 10C103.644 10 122 28.3563 122 51H126C126 26.1472 105.853 6 81 6V10ZM40 51C40 28.3563 58.3563 10 81 10V6C56.1472 6 36 26.1472 36 51H40ZM40 71V51H36V71H40ZM38 73H50V69H38V73ZM48 51V71H52V51H48ZM81 18C62.7746 18 48 32.7746 48 51H52C52 34.9837 64.9837 22 81 22V18ZM114 51C114 32.7746 99.2254 18 81 18V22C97.0163 22 110 34.9837 110 51H114ZM114 71V51H110V71H114ZM112 73H124V69H112V73Z",
    fill: "#0FE90C",
    mask: "url(#path-1-outside-1_348_3514)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82 8V7H81C56.6995 7 37 26.6995 37 51V71V72H38H50H51V71V51C51 34.4315 64.4315 21 81 21H82V20V8Z",
    fill: "#0C9406",
    stroke: "#0C9406",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 71,
    width: 122,
    height: 84,
    rx: 6,
    fill: "#0C9406"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 71,
    width: 16,
    height: 84,
    fill: "#0FE90C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 77C20 73.6863 22.6863 71 26 71H65V155H26C22.6863 155 20 152.314 20 149V77Z",
    fill: "#14FF0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockClose);
export default __webpack_public_path__ + "static/media/padlock-close.83c47b9ccced5e3884d3faa1e51236d7.svg";
export { ForwardRef as ReactComponent };